import styled from 'styled-components'
import { laranja, orange, brand } from '../../../styles/colors'
import { breakpoints } from '../../../styles/breakpoints'

export const Section = styled.section`
  background-color: ${brand.sand};

  h2 {
    color: ${laranja.terra}
  }

  .line {
    border-top: 1px solid ${orange.default};
    width: 100%;
    height: 3px;
    margin-top: 25px;
    position: absolute;
    z-index: 1;
  }

  ul.react-multi-carousel-track {
    height: 440px;

    @media(min-width: ${breakpoints.md}) {
      height: 270px;
    }
    @media(min-width: ${breakpoints.lg}) {
      height: 230px;
    }
    @media(min-width: ${breakpoints.xl}) {
      height: 230px;
    }
  }
  .react-multiple-carousel {
    &__arrow--right {
      @media(min-width: ${breakpoints.lg}) {
        right: 30%;
      }
    }
    &__arrow--left {
      @media(min-width: ${breakpoints.lg}) {
        left: 30%;
      }
    }
  }
  .react-multi-carousel-dot {
    button {
      background-color: ${orange.extra};
    }
  }

  .react-multiple-carousel__arrow--right {
    right: calc(40% - 100px);
  }

  .react-multiple-carousel__arrow--left {
    left: calc(40% - 100px);
  }
`

export const Years = styled.div`
  width: 100%;
  height: 70px;
  position: relative;
  overflow: hidden;
  z-index: 1;
  
  h2 {
    background-color: #FCF8EE;
    padding: 0 15px 0 15px;
  }
`

export const Desc = styled.p`
  max-width: 750px;
  margin: 0 auto;
`
